import type { FaireProductEntity } from "../../entity_types/product";

export const catalog_prod_prod_89: FaireProductEntity = {
  token: "catalog_prod_prod-89",
  type: "product",
  name: "Accent Piece - Style 2",
  brandName: "Audrey's Home & Gift",
  imageUrl:
    "https://images.unsplash.com/photo-1558618666-fcd25c85cd64?w=400&h=400&fit=crop",
  priceDollars: 39.39,
  msrpDollars: 98.48,
  sku: "AN0089",
  caseSize: 6,
  material: "Ceramic",
  collectionToken: "col_andean-touch",
  isNew: false,
  isBestseller: false,
  isPreviouslyOrdered: true,
  inStock: true,
  stockLevel: 294,
  description: "Beautiful Andean Touch piece perfect for any home.",
  categoryTokens: ["catalog_cat_stationery-writing"],
  tags: [],
  brandToken: "catalog_brand_audreys_home_gift",
  meta: {
    source: "mock",
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "common-sets-db-backfill",
  },
};
